import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default class extends Controller {
  static values = {
    loop: String,
    spaceBetween: Number,
    spaceBetweenSp: Number,
    pagination: Boolean,
    navigation: Boolean,
    offsetBefore: Number,
    offsetBeforeSp: Number,
    offsetAfter: Number,
    offsetAfterSp: Number,
  };

  connect() {
    new Swiper(this.element, {
      modules: [Navigation, Pagination],
      slidesPerView: "auto",
      loop: this.loopValue === "true",
      spaceBetween: this.spaceBetweenSpValue || 0,
      slidesOffsetBefore: this.offsetBeforeSpValue || this.offsetBeforeValue || 0,
      slidesOffsetAfter: this.offsetAfterSpValue || this.offsetAfterValue || 0,
      pagination: this.paginationValue
        ? {
            el: ".swiper-pagination",
            clickable: true,
          }
        : false,
      navigation: this.navigationValue
        ? {
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
          }
        : false,
      breakpoints: {
        // when window width is >= 992px
        992: {
          spaceBetween: this.spaceBetweenValue || 0,
          slidesOffsetBefore: this.offsetBeforeValue || 0,
          slidesOffsetAfter: this.offsetAfterValue || 0,
        },
      },
    });
  }
}
